/* Kkumi pager (JS side).
 *
 * The sitewide paged-carousel control — a generalisation of the PDP sleeve
 * guide's pager (`.kkpsg__pager`) so JS-rendered grids (wishlist, club redeem)
 * reuse the same prev/next + dots UX. Pages stay in the DOM (toggled `hidden`),
 * so anything that queries the cards (selection, add-all) keeps working across
 * pages. Visuals live in `.kk-pager` (assets/kkumi-tokens.css).
 *
 * Usage — build N page elements (each `data-kk-page="i"`, all but the active one
 * `hidden`) inside a root, append the nav, then mount:
 *   root.insertAdjacentHTML('beforeend', KKSkel ? '' : '');           // pages first
 *   root.insertAdjacentHTML('beforeend', KKPager.navHTML(pageCount)); // then nav
 *   KKPager.mount(root);                       // wires prev/next/dots
 * Set `root._kkOnPage = fn` to be notified on page change (receives the index).
 */
(function () {
  'use strict';
  if (window.KKPager) return;

  var PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function navHTML(count, active) {
    active = active || 0;
    if (count <= 1) return '';
    var dots = '';
    for (var i = 0; i < count; i++) {
      var on = i === active;
      dots += '<button type="button" class="kk-pager__dot' + (on ? ' is-active' : '') +
        '" data-kk-pager-dot="' + i + '" role="tab" aria-selected="' + (on ? 'true' : 'false') +
        '" aria-label="Page ' + (i + 1) + ' of ' + count + '"></button>';
    }
    return '<nav class="kk-pager" aria-label="Pages" data-kk-pager-nav>' +
      '<button type="button" class="kk-pager__arrow" data-kk-pager-prev aria-label="Previous"' + (active === 0 ? ' disabled' : '') + '>' + PREV + '</button>' +
      '<div class="kk-pager__dots" role="tablist">' + dots + '</div>' +
      '<button type="button" class="kk-pager__arrow" data-kk-pager-next aria-label="Next"' + (active === count - 1 ? ' disabled' : '') + '>' + NEXT + '</button>' +
      '</nav>';
  }

  function mount(root) {
    var pages = [].slice.call(root.querySelectorAll('[data-kk-page]'));
    if (pages.length <= 1) return null;
    var nav = root.querySelector('[data-kk-pager-nav]');
    var dots = nav ? [].slice.call(nav.querySelectorAll('[data-kk-pager-dot]')) : [];
    var prev = nav && nav.querySelector('[data-kk-pager-prev]');
    var next = nav && nav.querySelector('[data-kk-pager-next]');
    var current = parseInt(root.getAttribute('data-kk-active-page'), 10) || 0;

    function show(n) {
      if (n < 0 || n >= pages.length || n === current) return;
      pages.forEach(function (p, i) { p.hidden = i !== n; });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === n);
        d.setAttribute('aria-selected', i === n ? 'true' : 'false');
      });
      if (prev) prev.disabled = n === 0;
      if (next) next.disabled = n === pages.length - 1;
      current = n;
      root.setAttribute('data-kk-active-page', String(n));
      if (typeof root._kkOnPage === 'function') root._kkOnPage(n);
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(Math.min(pages.length - 1, current + 1)); if (dots[current]) dots[current].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(Math.max(0, current - 1)); if (dots[current]) dots[current].focus(); }
      });
    });
    return { show: show };
  }

  window.KKPager = { navHTML: navHTML, mount: mount };
})();
